import { PataviumRole } from '../models/request-and-responses/rest-api/enums/role.enum.model';
import { PhaseContract } from '../models/request-and-responses/rest-api/enums/phaseContract.enum';
import { PhaseObject, PhaseObjects } from './phaseObjects';

const adminAvailablePhases: PhaseContract[] = [
    PhaseContract.ToConfirmByPatavium,
    PhaseContract.Exportable,
    PhaseContract.StopForErrors,
    PhaseContract.CancelForChangingOfMind,
    PhaseContract.CancelForExceedingTime,
    PhaseContract.Rejected,
    PhaseContract.Draft,
    PhaseContract.ExportFail,
    PhaseContract.ExportSuccess,
    PhaseContract.ExportPartial,
    PhaseContract.ExportInProgess,
    PhaseContract.Validate,
    PhaseContract.PreCheckOk,
    PhaseContract.SwitchingRequest,
    PhaseContract.SwitchingAcquired,
    PhaseContract.Conclusion,
    PhaseContract.SwitchingVerification,
    PhaseContract.ConclusionPartial,
    PhaseContract.StoppedByAgency,
    PhaseContract.InAttesaDiAdesione,
    PhaseContract.InAttesaDiAdesionePec,
    PhaseContract.AdesioneConfermata,
    PhaseContract.AnnullatoDalCliente,
    PhaseContract.AnnullatoCausaAgenzia,
    PhaseContract.AnnullatoCausaCte,
    PhaseContract.RespintoTeleselling,
    PhaseContract.AttesaChiamataVerifica,
    PhaseContract.RifiutatoDopoChiamataVerifica,
    PhaseContract.AnnullatoCausaVincoliTemporali,
    PhaseContract.RespintoCausaChiamataPreAdesione,
    PhaseContract.RespintoCausaChiamataAdesione,
    PhaseContract.AnnullatoCausaClienteIrreperibile,
    PhaseContract.AnnullatoCausaNumeroTelefonicoErrato,
    PhaseContract.CheckChiamataDiVerifica,
    PhaseContract.RipensamentoCausaAgenzia,
    PhaseContract.RifiutoRegistrazioneChiamata,
    PhaseContract.RifiutatoCausaChiamataVerifica,
    PhaseContract.RespintoCausaAllegatoChiamataPreAdesione,
    PhaseContract.AttesaChiamataVerifica,
    PhaseContract.PreCheckKo,
    PhaseContract.CambioPiano,
    PhaseContract.AttesaEsitoDistributore,
    PhaseContract.RinnovoPerScadenza,
    PhaseContract.Rebranding,
    PhaseContract.ReCallDisdettato,
    PhaseContract.AttesaSaldo,
    PhaseContract.PropostaAnnullata,
    PhaseContract.RifiutoProposta,
    PhaseContract.AttesaRestituzionePlico,
    PhaseContract.CheckVocalOrder,
    PhaseContract.PropostaScaduta,
    PhaseContract.RebrandingAjoSrl,
    PhaseContract.InAttesaDiVerificaPec,
    PhaseContract.AttesaChiamataBenvenuto,
    PhaseContract.ChiamataBenvenutoEseguita,
    PhaseContract.AttesaRicevimentoPlicoFirmato,
    PhaseContract.RichiestaDisdetta,
    PhaseContract.RichiestaCessazione,
    PhaseContract.AttesaVocalOrder,
    PhaseContract.VocalOrderNonConforme,
    PhaseContract.PreScreeningKO,
    PhaseContract.RespintoTuristaEnergetico,
    PhaseContract.AnnullatoDatiIncongruenti,
    PhaseContract.AnnullatoSwitchMultipli,
    PhaseContract.AnnullatoProvenienzaDefault,
    PhaseContract.DidettatoVolutaAttivazione,
    PhaseContract.RipensamentoTelefonico,
    PhaseContract.RipensamentoScritto,
    PhaseContract.RipensamentoCondizioniEconomiche,
    PhaseContract.RipensamentoContatoreChiuso,
    PhaseContract.RipensamentoFrequenzaFatturazione,
    PhaseContract.RipensamentoContrattoSottoscrittoInconsapevolmente,
    PhaseContract.RipensamentoTerminiPagamento,
    PhaseContract.AnnullatoMancanzaDelega,
    PhaseContract.AnnullatoIntestatarioDiverso,
    PhaseContract.ChiamataBenvenutoNonRisponde,
    PhaseContract.PreVerificheBackoffice
];
const agencyOperatorAvailablePhases: PhaseContract[] = [
    PhaseContract.ToConfirmByAgency,
    PhaseContract.ToConfirmByPatavium,
    PhaseContract.StopForErrors,
    PhaseContract.CancelForChangingOfMind,
    PhaseContract.CancelForExceedingTime,
    PhaseContract.Rejected,
    PhaseContract.Draft,
    PhaseContract.ExportPartial,
    PhaseContract.SwitchingVerification,
    PhaseContract.SwitchingRequest,
    PhaseContract.Validate,
    PhaseContract.Conclusion,
    PhaseContract.LoadingExport,
    PhaseContract.ConclusionPartial,
    PhaseContract.StoppedByAgency,
    PhaseContract.CheckChiamataDiVerifica,
    PhaseContract.RipensamentoCausaAgenzia,
    PhaseContract.RifiutoRegistrazioneChiamata,
    PhaseContract.RifiutatoCausaChiamataVerifica,
    PhaseContract.AttesaChiamataVerifica,
    PhaseContract.RespintoCausaAllegatoChiamataPreAdesione,
    PhaseContract.PreCheckKo,
    PhaseContract.CambioPiano,
    PhaseContract.AttesaEsitoDistributore,
    PhaseContract.InAttesaDiVerificaPec,
    PhaseContract.AttesaChiamataBenvenuto,
    PhaseContract.ChiamataBenvenutoEseguita,
    PhaseContract.AttesaRicevimentoPlicoFirmato,
    PhaseContract.RichiestaDisdetta,
    PhaseContract.RichiestaCessazione,
    PhaseContract.AnnullatoDatiIncongruenti,
    PhaseContract.AnnullatoSwitchMultipli,
    PhaseContract.AnnullatoProvenienzaDefault,
    PhaseContract.DidettatoVolutaAttivazione,
    PhaseContract.RipensamentoTelefonico,
    PhaseContract.RipensamentoScritto,
    PhaseContract.RipensamentoCondizioniEconomiche,
    PhaseContract.RipensamentoContatoreChiuso,
    PhaseContract.RipensamentoFrequenzaFatturazione,
    PhaseContract.RipensamentoContrattoSottoscrittoInconsapevolmente,
    PhaseContract.RipensamentoTerminiPagamento,
    PhaseContract.AnnullatoMancanzaDelega,
    PhaseContract.AnnullatoIntestatarioDiverso,
    PhaseContract.ChiamataBenvenutoNonRisponde,
    PhaseContract.PreVerificheBackoffice
];
const agencyAvailablePhases: PhaseContract[] = [
    PhaseContract.ToConfirmByAgency,
    PhaseContract.ToConfirmByPatavium,
    PhaseContract.StopForErrors,
    PhaseContract.CancelForChangingOfMind,
    PhaseContract.CancelForExceedingTime,
    PhaseContract.Rejected,
    PhaseContract.Draft,
    PhaseContract.ExportPartial,
    PhaseContract.SwitchingVerification,
    PhaseContract.SwitchingRequest,
    PhaseContract.Validate,
    PhaseContract.Conclusion,
    PhaseContract.LoadingExport,
    PhaseContract.ConclusionPartial,
    PhaseContract.StoppedByAgency,
    PhaseContract.CheckChiamataDiVerifica,
    PhaseContract.RipensamentoCausaAgenzia,
    PhaseContract.RifiutoRegistrazioneChiamata,
    PhaseContract.RifiutatoCausaChiamataVerifica,
    PhaseContract.AttesaChiamataVerifica,
    PhaseContract.RespintoCausaAllegatoChiamataPreAdesione,
    PhaseContract.PreCheckKo,
    PhaseContract.CambioPiano,
    PhaseContract.AttesaEsitoDistributore,
    PhaseContract.InAttesaDiVerificaPec,
    PhaseContract.AttesaChiamataBenvenuto,
    PhaseContract.ChiamataBenvenutoEseguita,
    PhaseContract.AttesaRicevimentoPlicoFirmato,
    PhaseContract.RichiestaDisdetta,
    PhaseContract.RichiestaCessazione,
    PhaseContract.AnnullatoDatiIncongruenti,
    PhaseContract.AnnullatoSwitchMultipli,
    PhaseContract.AnnullatoProvenienzaDefault,
    PhaseContract.DidettatoVolutaAttivazione,
    PhaseContract.RipensamentoTelefonico,
    PhaseContract.RipensamentoScritto,
    PhaseContract.RipensamentoCondizioniEconomiche,
    PhaseContract.RipensamentoContatoreChiuso,
    PhaseContract.RipensamentoFrequenzaFatturazione,
    PhaseContract.RipensamentoContrattoSottoscrittoInconsapevolmente,
    PhaseContract.RipensamentoTerminiPagamento,
    PhaseContract.AnnullatoMancanzaDelega,
    PhaseContract.AnnullatoIntestatarioDiverso,
    PhaseContract.ChiamataBenvenutoNonRisponde,
    PhaseContract.PreVerificheBackoffice
];
const pataviumOperatorAvailablePhases: PhaseContract[] = [
    PhaseContract.ToConfirmByPatavium,
    PhaseContract.Exportable,
    PhaseContract.StopForErrors,
    PhaseContract.CancelForChangingOfMind,
    PhaseContract.CancelForExceedingTime,
    PhaseContract.Rejected,
    PhaseContract.Draft,
    PhaseContract.ExportFail,
    PhaseContract.ExportSuccess,
    PhaseContract.ExportPartial,
    PhaseContract.ExportInProgess,
    PhaseContract.Validate,
    PhaseContract.PreCheckOk,
    PhaseContract.SwitchingRequest,
    PhaseContract.SwitchingAcquired,
    PhaseContract.Conclusion,
    PhaseContract.SwitchingVerification,
    PhaseContract.ConclusionPartial,
    PhaseContract.StoppedByAgency,
    PhaseContract.InAttesaDiAdesione,
    PhaseContract.InAttesaDiAdesionePec,
    PhaseContract.AdesioneConfermata,
    PhaseContract.AnnullatoDalCliente,
    PhaseContract.AnnullatoCausaAgenzia,
    PhaseContract.AnnullatoCausaCte,
    PhaseContract.RespintoTeleselling,
    PhaseContract.AttesaChiamataVerifica,
    PhaseContract.RifiutatoDopoChiamataVerifica,
    PhaseContract.AnnullatoCausaVincoliTemporali,
    PhaseContract.RespintoCausaChiamataPreAdesione,
    PhaseContract.RespintoCausaChiamataAdesione,
    PhaseContract.AnnullatoCausaClienteIrreperibile,
    PhaseContract.AnnullatoCausaNumeroTelefonicoErrato,
    PhaseContract.CheckChiamataDiVerifica,
    PhaseContract.RipensamentoCausaAgenzia,
    PhaseContract.RifiutoRegistrazioneChiamata,
    PhaseContract.RifiutatoCausaChiamataVerifica,
    PhaseContract.RespintoCausaAllegatoChiamataPreAdesione,
    PhaseContract.AttesaChiamataVerifica,
    PhaseContract.PreCheckKo,
    PhaseContract.CambioPiano,
    PhaseContract.AttesaEsitoDistributore,
    PhaseContract.RinnovoPerScadenza,
    PhaseContract.Rebranding,
    PhaseContract.ReCallDisdettato,
    PhaseContract.AttesaSaldo,
    PhaseContract.PropostaAnnullata,
    PhaseContract.RifiutoProposta,
    PhaseContract.AttesaRestituzionePlico,
    PhaseContract.CheckVocalOrder,
    PhaseContract.PropostaScaduta,
    PhaseContract.RebrandingAjoSrl,
    PhaseContract.InAttesaDiVerificaPec,
    PhaseContract.AttesaChiamataBenvenuto,
    PhaseContract.ChiamataBenvenutoEseguita,
    PhaseContract.AttesaRicevimentoPlicoFirmato,
    PhaseContract.RichiestaDisdetta,
    PhaseContract.RichiestaCessazione,
    PhaseContract.AttesaVocalOrder,
    PhaseContract.VocalOrderNonConforme,
    PhaseContract.PreScreeningKO,
    PhaseContract.RespintoTuristaEnergetico,
    PhaseContract.AnnullatoDatiIncongruenti,
    PhaseContract.AnnullatoSwitchMultipli,
    PhaseContract.AnnullatoProvenienzaDefault,
    PhaseContract.DidettatoVolutaAttivazione,
    PhaseContract.RipensamentoTelefonico,
    PhaseContract.RipensamentoScritto,
    PhaseContract.RipensamentoCondizioniEconomiche,
    PhaseContract.RipensamentoContatoreChiuso,
    PhaseContract.RipensamentoFrequenzaFatturazione,
    PhaseContract.RipensamentoContrattoSottoscrittoInconsapevolmente,
    PhaseContract.RipensamentoTerminiPagamento,
    PhaseContract.AnnullatoMancanzaDelega,
    PhaseContract.AnnullatoIntestatarioDiverso,
    PhaseContract.ChiamataBenvenutoNonRisponde,
    PhaseContract.PreVerificheBackoffice
];
const specializedOperatorAvailablePhases: PhaseContract[] = [];
const agentAvailablePhases: PhaseContract[] = [
    PhaseContract.ToConfirmByAgency,
    PhaseContract.ToConfirmByPatavium,
    PhaseContract.StopForErrors,
    PhaseContract.CancelForChangingOfMind,
    PhaseContract.CancelForExceedingTime,
    PhaseContract.Rejected,
    PhaseContract.Draft,
    PhaseContract.ExportPartial,
    PhaseContract.SwitchingVerification,
    PhaseContract.SwitchingRequest,
    PhaseContract.Validate,
    PhaseContract.Conclusion,
    PhaseContract.LoadingExport,
    PhaseContract.ConclusionPartial,
    PhaseContract.StoppedByAgency,
    PhaseContract.CheckChiamataDiVerifica,
    PhaseContract.RipensamentoCausaAgenzia,
    PhaseContract.RifiutoRegistrazioneChiamata,
    PhaseContract.RifiutatoCausaChiamataVerifica,
    PhaseContract.AttesaChiamataVerifica,
    PhaseContract.RespintoCausaAllegatoChiamataPreAdesione,
    PhaseContract.PreCheckKo,
    PhaseContract.CambioPiano,
    PhaseContract.AttesaEsitoDistributore,
    PhaseContract.InAttesaDiVerificaPec,
    PhaseContract.AttesaChiamataBenvenuto,
    PhaseContract.ChiamataBenvenutoEseguita,
    PhaseContract.AttesaRicevimentoPlicoFirmato,
    PhaseContract.RichiestaDisdetta,
    PhaseContract.RichiestaCessazione,
    PhaseContract.AnnullatoDatiIncongruenti,
    PhaseContract.AnnullatoSwitchMultipli,
    PhaseContract.AnnullatoProvenienzaDefault,
    PhaseContract.DidettatoVolutaAttivazione,
    PhaseContract.RipensamentoTelefonico,
    PhaseContract.RipensamentoScritto,
    PhaseContract.RipensamentoCondizioniEconomiche,
    PhaseContract.RipensamentoContatoreChiuso,
    PhaseContract.RipensamentoFrequenzaFatturazione,
    PhaseContract.RipensamentoContrattoSottoscrittoInconsapevolmente,
    PhaseContract.RipensamentoTerminiPagamento,
    PhaseContract.AnnullatoMancanzaDelega,
    PhaseContract.AnnullatoIntestatarioDiverso,
    PhaseContract.ChiamataBenvenutoNonRisponde,
    PhaseContract.PreVerificheBackoffice
];

const adminDefaultActivePhases: PhaseContract[] = [
    PhaseContract.CancelForChangingOfMind,
    PhaseContract.Rejected,
    PhaseContract.CancelForExceedingTime,
    PhaseContract.StopForErrors,
    PhaseContract.ExportInProgess,
    PhaseContract.ToConfirmByPatavium,
    PhaseContract.ToConfirmByAgency
];
const pataviumOperatorDefaultActivePhases: PhaseContract[] = [
    PhaseContract.Draft,
    PhaseContract.ToConfirmByPatavium,
    PhaseContract.StopForErrors,
    PhaseContract.ExportFail,
    PhaseContract.ExportPartial
];
const agencyDefaultActivePhases: PhaseContract[] = [
    PhaseContract.Draft,
    PhaseContract.ToConfirmByAgency,
    PhaseContract.StopForErrors,
    PhaseContract.ExportFail,
    PhaseContract.ExportPartial
];
const agencyOperatorDefaultActivePhases: PhaseContract[] = [
    PhaseContract.Draft,
    PhaseContract.ToConfirmByAgency,
    PhaseContract.StopForErrors,
    PhaseContract.ExportFail,
    PhaseContract.ExportPartial
];
const specializedOperatorDefaultActivePhases: PhaseContract[] = [];
const agentDefaultActivePhases: PhaseContract[] = [
    PhaseContract.Draft,
    PhaseContract.ToConfirmByAgency,
    PhaseContract.StopForErrors,
    PhaseContract.ExportFail,
    PhaseContract.ExportPartial
];

const telesellingPhases: PhaseContract[] = [
    PhaseContract.InAttesaDiAdesione,
    PhaseContract.AdesioneConfermata,
    PhaseContract.AnnullatoDalCliente,
    PhaseContract.AnnullatoCausaAgenzia,
    PhaseContract.AnnullatoCausaCte,
    PhaseContract.RespintoTeleselling,
    PhaseContract.AnnullatoCausaVincoliTemporali,
    PhaseContract.RespintoCausaChiamataPreAdesione,
    PhaseContract.RespintoCausaChiamataAdesione,
    PhaseContract.AnnullatoCausaClienteIrreperibile,
    PhaseContract.AnnullatoCausaNumeroTelefonicoErrato,
    PhaseContract.CheckVocalOrder
];
const adesioneADistanzaPhases: PhaseContract[] = [
    PhaseContract.InAttesaDiAdesionePec
];

export class ContractPhaseFilters {
    private readonly availablePhases: PhaseContract[];
    private activePhases: PhaseContract[];
    private inactivePhases: PhaseContract[];
    private _activeFilters: PhaseObject[];
    private _inactiveFilters: PhaseObject[];

    constructor(role: PataviumRole, active_phases: PhaseContract[], canDoTelesales: boolean, canDoAdesioneADistanza: boolean) {
        // init variables with a default (conservative) value
        this.availablePhases = [];

        this.activePhases = [];
        this.inactivePhases = [];

        this._activeFilters = [];
        this._inactiveFilters = [];

        // set role-depending variables and exit if role is not handled
        switch (role) {
            case PataviumRole.Admin:
                this.availablePhases = adminAvailablePhases;
                if (active_phases == null) {
                    active_phases = adminDefaultActivePhases;
                }
                break;
            case PataviumRole.SpecializedOperator:
                this.availablePhases = specializedOperatorAvailablePhases;
                if (active_phases == null) {
                    active_phases = specializedOperatorDefaultActivePhases;
                }
                break;
            case PataviumRole.Agent:
                this.availablePhases = agentAvailablePhases;
                if (active_phases == null) {
                    active_phases = agentDefaultActivePhases;
                }
                break;
            case PataviumRole.AgencyOperator:
                this.availablePhases = agencyOperatorAvailablePhases;
                if (active_phases == null) {
                    active_phases = agencyOperatorDefaultActivePhases;
                }
                if (canDoTelesales) {
                    this.availablePhases = this.availablePhases.concat(telesellingPhases);
                }
                // Condizione sufficiente e necessaria. Vedi task P-1-T482
                if (canDoAdesioneADistanza) {
                    this.availablePhases = this.availablePhases.concat(adesioneADistanzaPhases);
                }
                break;
            case PataviumRole.Agency:
                this.availablePhases = agencyAvailablePhases;
                if (active_phases == null) {
                    active_phases = agencyDefaultActivePhases;
                }
                if (canDoTelesales) {
                    this.availablePhases = this.availablePhases.concat(telesellingPhases);
                }
                // Condizione sufficiente e necessaria. Vedi task P-1-T482
                if (canDoAdesioneADistanza) {
                    this.availablePhases = this.availablePhases.concat(adesioneADistanzaPhases);
                }
                break;
            case PataviumRole.BackOfficeOperator:
                this.availablePhases = pataviumOperatorAvailablePhases;
                if (active_phases == null) {
                    active_phases = pataviumOperatorDefaultActivePhases;
                }
                break;
            default:
                console.error(
                    `The role ${role} is not handled. ` +
                        `There won't be nor active nor inactive filters at all.`
                );
                return;
        }

        // remove duplicates in active_phases and available filters
        active_phases = ContractPhaseFilters.removeDuplicatesFrom(active_phases);
        this.activePhases = ContractPhaseFilters.removeDuplicatesFrom(this.activePhases);

        // filter active_phases and keep only those that are available
        const activeAvailableFilters: PhaseContract[] = this.keepOnlyAvailableFilters(
            active_phases
        );
        if (activeAvailableFilters.length !== active_phases.length) {
            console.warn(
                `Active filters should have been ${active_phases.length} ` +
                    `but they have been filtered to ${activeAvailableFilters.length}`
            );
        }

        // set active and inactive filters
        for (const f of this.availablePhases) {
            if (activeAvailableFilters.includes(f)) {
                this.activePhases.push(f);
            } else {
                this.inactivePhases.push(f);
            }
        }

        // update filters
        this.updateFilters();
    }

    private static removeDuplicatesFrom(list: PhaseContract[]) {
        try {
            return list.filter((phase, index) => list.indexOf(phase) === index);
        } catch (e) {
            console.error(
                `Error trying removing duplicates from list. ` + `Empty list will be returned`,
                list,
                e
            );
            return [];
        }
    }

    private updateFilters(): void {
        this._activeFilters = PhaseObjects.filter(po => this.activePhases.includes(po.phase));
        this._inactiveFilters = PhaseObjects.filter(po => this.inactivePhases.includes(po.phase));

        console.debug(`There are ${this.activeFilters.length} active filters`);
        if (this.activeFilters.length !== this.activePhases.length) {
            console.warn(
                `Something has gone wrong with filters: ` +
                    `the number of active phases does not match the number of active filters`
            );
        }

        console.debug(`There are ${this.inactiveFilters.length} inactive filters`);
        if (this._inactiveFilters.length !== this.inactivePhases.length) {
            console.warn(
                `Something has gone wrong with filters: ` +
                    `the number of inactive phases does not match the number of inactive filters`
            );
        }
    }

    setActive(phase: PhaseContract): void {
        if (!this.availablePhases.includes(phase)) {
            console.warn(
                `Cannot set to active the phase ${phase} ` +
                    `because it's not present in the available filters`
            );
            return;
        }
        // move from inactive to active
        this.activePhases.push(phase);
        this.activePhases = ContractPhaseFilters.removeDuplicatesFrom(this.activePhases);

        this.inactivePhases = this.inactivePhases.filter(p => p !== phase);

        // update filters
        this.updateFilters();
    }

    setInactive(phase: PhaseContract) {
        if (!this.availablePhases.includes(phase)) {
            console.warn(
                `Cannot set to inactive the phase ${phase} ` +
                    `because it's not present in the available filters`
            );
            return;
        }
        // move from active to inactive
        this.inactivePhases.push(phase);
        this.inactivePhases = ContractPhaseFilters.removeDuplicatesFrom(this.inactivePhases);

        this.activePhases = this.activePhases.filter(p => p !== phase);

        // update filters
        this.updateFilters();
    }

    get activeFilters(): PhaseObject[] {
        return this._activeFilters;
    }

    get inactiveFilters(): PhaseObject[] {
        return this._inactiveFilters;
    }

    /*private isActive(phase: PhaseContract): boolean {
        try {
            return this.activePhases.includes(phase);
        } catch (e) {
            console.error(
                `Exception trying to find out if phase ${phase} is active. ` +
            `False will be returned`,
                e
            );
            return false;
        }
    }*/

    /*private isInactive(phase: PhaseContract): boolean {
        try {
            return this.inactivePhases.includes(phase);
        } catch (e) {
            console.error(
                `Exception trying to find out if phase ${phase} is inactive. ` +
                `False will be returned`,
                e
            );
            return false;
        }
    }*/

    private keepOnlyAvailableFilters(filters: PhaseContract[]): PhaseContract[] {
        try {
            console.debug(`There are ${this.availablePhases.length} available phases`);
            if (filters == null || filters.length === 0) {
                return [];
            }
            const discardedFilters = [];
            const availableFilters = filters.filter(a => {
                if (!this.availablePhases.includes(a)) {
                    discardedFilters.push(a);
                    return false;
                }
                return true;
            });
            if (discardedFilters.length) {
                console.debug(`Some filters have been discarded ${discardedFilters}`);
            }
            return availableFilters;
        } catch (e) {
            console.error(
                `Error trying keep only available filters. ` + `Empty list will be returned.`,
                e
            );
            return [];
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/helpers/contractPhaseFilters.class.ts